import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { PrintButtonsToolbar, PrintTable, PrintLoadNextButton } from '@bibliocommons/print';
import FormatIndicator from '@bibliocommons/format-indicator';
import PublicationDate from '@bibliocommons/shared-publication-date';
import BibBrief from '@bibliocommons/shared-bib-brief';
import ShortFormattedDate from '../../../shared/ShortFormattedDate';
import BcReactComponent from '@bibliocommons/base-bc-react-component';

import './RecentlyReturnedPrintList.scss';

const renderFormat = (format, index, item) => (
  <div>
    <FormatIndicator format={format} />
    <PublicationDate publicationDate={item.getIn(['bib', 'briefInfo', 'publicationDate'])} />
  </div>
);

const renderTitle = (title, index, item) => (
  <BibBrief
    bib={item.getIn(['bib', 'briefInfo'])}
    titleTag="span"
    renderTitleAsLink={false}
    renderAuthorsAsLink={false} />
);


const renderCheckoutDate = (checkedoutDate) => (
  <ShortFormattedDate value={checkedoutDate} />
);


export default class RecentlyReturnedPrintList extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleUpdatePage');
  }

  handleUpdatePage() {
    let page = parseInt(this.props.router.location.query.page || 1, 10);
    page += 1;
    const { location, router, accountId } = this.props;
    router.push({
      ...location,
      query: {
        ...location.query,
        page
      }
    });

    this.props.RecentlyReturnedActions.fetchReturnHistory({
      ...location.query,
      page,
      accountId
    });
  }

  render() {
    const { items, pagination, isFetching } = this.props;

    return (
      <div className="cp-holds-print-list">
        <PrintButtonsToolbar numItemsToPrint={items.size}>
          <PrintLoadNextButton
            handleClick={this.handleUpdatePage}
            numToLoad={pagination.get('size')}
            totalPages={pagination.get('totalPages')}
            currentPage={(pagination.get('number') + 1)}
            isLoading={isFetching} />
        </PrintButtonsToolbar>
        <h1><FormattedMessage id="section_title_recently_returned" /></h1>

        <FormattedMessage id="label_number_of_items" values={{ count: items.size }}>
          { (message) => <p>{message}</p>}
        </FormattedMessage>

        <PrintTable
          rows={items}
          fields={[
            { key: 'bib.briefInfo.title', type: 'item-title', headerKey: 'table_headings_title', transformationMap: renderTitle },
            { key: 'bib.briefInfo.format', type: 'item-format', headerKey: 'table_headings_format', transformationMap: renderFormat },
            { key: 'bib.briefInfo.callNumber', type: 'item-callNumber', headerKey: 'callNumber' },
            { key: 'barcode', type: 'item-barcode', headerKey: 'form_label_barcode' },
            { key: 'checkedoutDate', type: 'item-checkedoutDate', headerKey: 'section_title_checkedout', transformationMap: renderCheckoutDate }
          ]} />
        <div className="page-info">
          <FormattedMessage id="form_label_current_page" values={{ current_page: (this.props.router.location.query.page || 1) }} />
          &nbsp;
          <FormattedMessage id="form_label_total_pages" values={{ total_pages: pagination.get('pages') }} />
        </div>
      </div>
    );
  }
}

RecentlyReturnedPrintList.propTypes = {
  items: ImmutablePropTypes.list,
  pagination: ImmutablePropTypes.map,
  isFetching: PropTypes.bool,
  RecentlyReturnedActions: PropTypes.objectOf(PropTypes.func),
  accountId: PropTypes.number
};



// WEBPACK FOOTER //
// ./app/components/borrowing/recentlyreturned/RecentlyReturnedPrintList/RecentlyReturnedPrintList.jsx